import React, { useState } from 'react';
import { Typography, Box, Link } from '@mui/material';
import TextInputBox from '../../components/TextInputBox';
import { LOGIN_CHECKRESETMAIL, LOGIN_LOGIN } from '../../constants';
import ButtonBox from '../../components/ButtonBox';
import '../../style/Login.css';

interface ForgetPasswordProps {
    setLoginPage: React.Dispatch<React.SetStateAction<string>>;
}

const ForgetPassword: React.FC<ForgetPasswordProps> = ({ setLoginPage }) => {
    const [formValues, setFormValues] = useState({
        organization: '',
        email: '',
    });

    const handleChange = (field: string) => (e: React.ChangeEvent<HTMLInputElement>) => {
        setFormValues((prevValues) => ({ ...prevValues, [field]: e.target.value }));
    };

    const handleResetPassword = (e: React.FormEvent) => {
        e.preventDefault();
        // 在此添加重設密碼邏輯，例如請求發送重設連結到使用者的郵件
        console.log(`Organization: ${formValues.organization}, Email: ${formValues.email}`);
        setLoginPage(LOGIN_CHECKRESETMAIL);
    };

    return (
        <>
            <Typography className='login_typography_title'>
                Reset Password
            </Typography>

            <TextInputBox
                label="Organization name"
                value={formValues.organization}
                onChange={handleChange('organization')}
                placeholder="Please enter your organization name"
            />

            <TextInputBox
                label="Email"
                value={formValues.email}
                onChange={handleChange('email')}
                placeholder="Please enter your email"
                type="email"
            />

            <ButtonBox
                text="Email me a reset link"
                onClick={handleResetPassword}
            />

            <Box display="flex" justifyContent="center" mt={2}>
                <Link
                    href="#"
                    color="primary"
                    underline="none"
                    onClick={() => setLoginPage(LOGIN_LOGIN)}
                >
                    Back to log in
                </Link>
            </Box>
        </>
    );
};

export default ForgetPassword;
